import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const LoansPage = lazy(() => import('../pages/loans/page'));
const ApplyPage = lazy(() => import('../pages/apply/page'));
const CustomerProtectionPage = lazy(() => import('../pages/customer-protection/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const InvestorsPage = lazy(() => import('../pages/investors/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/about',
    element: <AboutPage />
  },
  {
    path: '/loans',
    element: <LoansPage />
  },
  {
    path: '/apply',
    element: <ApplyPage />
  },
  {
    path: '/customer-protection',
    element: <CustomerProtectionPage />
  },
  {
    path: '/complaints',
    element: <CustomerProtectionPage />
  },
  {
    path: '/contact',
    element: <ContactPage />
  },
  {
    path: '/investors',
    element: <InvestorsPage />
  },
  {
    path: '/privacy',
    element: <PrivacyPage />
  },
  {
    path: '/terms',
    element: <TermsPage />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;